import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Smartphone } from "lucide-react";

export default function DeviceSyncStatus() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => {
    const load = () => api.get("/sync-status/inspectors").then((r) => setItems(r.data));
    load();
    const iv = setInterval(load, 30_000);
    return () => clearInterval(iv);
  }, []);
  return (
    <div>
      <div className="eyebrow flex items-center gap-1"><Smartphone size={12}/> Sync</div>
      <h1 className="text-2xl font-bold" style={{ color: "var(--brand-navy)" }}>Device Sync Status</h1>
      <p className="text-sm text-[#4A627A] mt-1">Live pending record counts and last successful sync per inspector.</p>
      <div className="mt-4 overflow-x-auto hag-surface">
        <table className="w-full text-sm">
          <thead className="bg-[#FAF6F0] text-[#4A627A] uppercase text-xs tracking-widest">
            <tr>
              <th className="p-3 text-left">Inspector</th>
              <th className="p-3 text-left">Zone</th>
              <th className="p-3 text-left">Pending</th>
              <th className="p-3 text-left">Oldest queued</th>
              <th className="p-3 text-left">Last sync</th>
            </tr>
          </thead>
          <tbody>
            {items.map((i) => (
              <tr key={i.id} data-testid={`sync-${i.id}`} className={`border-t border-[#1B3A5C]/5 ${i.stale_24h ? "bg-red-50" : ""}`}>
                <td className="p-3 font-semibold">{i.name}</td>
                <td className="p-3">{i.zone || "—"}</td>
                <td className="p-3">
                  <span className={`status-chip ${i.pending_count === 0 ? "pace-green" : i.stale_24h ? "pace-red" : "pace-amber"}`}>
                    {i.pending_count}
                  </span>
                </td>
                <td className="p-3 text-xs text-[#4A627A]">{i.oldest_pending_at ? new Date(i.oldest_pending_at).toLocaleString() : "—"}</td>
                <td className="p-3 text-xs text-[#4A627A]">{i.last_synced_at ? new Date(i.last_synced_at).toLocaleString() : "—"}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="5" className="p-4 text-sm text-[#7C8E9E]">No inspector devices reporting yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
